import React from 'react';
import { Route, Routes } from 'react-router-dom';
// import { getPageName } from '../helpers/utils';
import loadable from '@loadable/component';

import DashboardLayout from './DashboardLayout';
// import ErrorLayout from './ErrorLayout';
import AuthBasicLayout from './AuthBasicLayout';

import Dashboard from '../components/dashboard/Dashboard';
/* integrations */
import IntegrationSettings from '../components/page/IntegrationSettings';
import SSOSettings from '../components/page/SSOSettings';
import OpenApiSettings from '../components/page/OpenApiSettings';
import SplunkSettings from '../components/page/SplunkSettings';

/* managed products */
import ManagedProductListing from '../components/page/ManagedProductListing';
import ManagedProductConfig from '../components/page/ManagedProductConfig';
import ManagedProductEdit from '../components/page/ManagedProductEdit';

/* Support */
import CreateSupportTicket from '../components/page/CreateSupportTicket';
import ViewSupportTickets from '../components/page/ViewSupportTickets';
import SupportTicketDetail from '../components/page/SupportTicketDetail';
import GetHelp from '../components/page/GetHelp';

/* tools */
import BugScrubTool from '../components/page/BugScrubTool';

/* users */
import ViewUsers from '../components/page/ViewUsers';
import ViewGroups from '../components/page/ViewGroups';
import RBACRoles from '../components/page/RBACRoles';

/* Documentation */
import VendorIntegrationList from '../components/page/VendorIntegrationList';
import VendorIntegrationDetail from '../components/page/VendorIntegrationDetail';
// import KbArticle from '../components/page/KbArticle';
import Profile from '../components/page/Profile';
import Faq from '../components/page/Faq';

// Admin
import SuperAdmin from '../components/page/SuperAdmin';

// Authentication
import Login from '../components/auth/basic/Login';
import Logout from '../components/auth/basic/Logout';
import Forbidden from '../components/auth/basic/Forbidden';
// import Registration from '../components/auth/basic/Registration';
import ForgetPassword from '../components/auth/basic/ForgetPassword';
import PasswordReset from '../components/auth/basic/PasswordReset';
import ConfirmMail from '../components/auth/basic/ConfirmMail';
// import LockScreen from '../components/auth/basic/LockScreen';
import Error404 from '../components/errors/Error404';
// import DashboardLayout from './DashboardLayout';
// const AuthBasicLayout = loadable(() => import('./AuthBasicLayout'));
const AuthCardRoutes = loadable(() => import('../components/auth/card/AuthCardRoutes'));
const AuthSplitRoutes = loadable(() => import('../components/auth/split/AuthSplitRoutes'));

const Layout = () => {
  // const { isFluid, isVertical, navbarStyle } = useContext(AppContext);
  // let location = useLocation();

  // useEffect(() => {
  //   console.log('dash layout');
  //   console.log('location', location.pathname);
  //   window.scrollTo(0, 0);
  // }, []);
  return (
    <div>
      <Routes>
        {/* Main Layout */}
        <Route element={<DashboardLayout />}>
          {/* Dashboard */}
          <Route path="/" element={<Dashboard />} />
          {/* 404 */}
          <Route path="*" element={<Error404 />} />
          {/* Admin routes */}
          <Route path={'super-admin'} element={<SuperAdmin />} />

          {/* Create vendors route with layout */}

          {/* Vendor routes */}
          <Route path={'vendors/:vendorId/configuration'} element={<ManagedProductConfig />} />
          <Route path={`vendors/:vendorId/products/`} element={<ManagedProductListing />} />
          <Route path={`vendors/:vendorId/products/new`} element={<ManagedProductEdit />} />
          <Route
            path={`vendors/:vendorId/products/:managedProductId/:managedProductName`}
            element={<ManagedProductEdit />}
          />

          {/* Integrations routes */}
          <Route path={`integrations/servicenow`} element={<IntegrationSettings />} />
          <Route path={`integrations/sso`} element={<SSOSettings />} />
          <Route path={`integrations/bugzero-api`} element={<OpenApiSettings />} />
          <Route path={`integrations/logging/splunk`} element={<SplunkSettings />} />

          {/* Tool routes */}
          <Route path="tools/bug-scrub-advisor" element={<BugScrubTool />} />
          {/* User routes */}
          <Route path="profile" element={<Profile />} />
          <Route path="users/view-users" element={<ViewUsers />} />
          <Route path="users/view-groups" element={<ViewGroups />} />
          <Route path="users/view-roles" element={<RBACRoles />} />

          {/* Documentation routes */}
          {/* <Route path="documentation/kb-articles" element={<KbArticle />} /> */}
          <Route path="documentation/:category" element={<VendorIntegrationList />} />
          <Route path="documentation/:slug/:slug" element={<VendorIntegrationDetail />} />
          <Route path="pages/faq" element={<Faq />} />

          {/* Support routes */}
          <Route path="support/create-ticket" element={<CreateSupportTicket />} />
          <Route path="support/view-tickets" element={<ViewSupportTickets />} />
          <Route path="support/view-tickets/:id" element={<SupportTicketDetail />} />
          <Route path="support/get-help" element={<GetHelp />} />
        </Route>

        <Route path="authentication/card" element={<AuthCardRoutes />} />
        <Route path="authentication/split" element={<AuthSplitRoutes />} />
        {/* <Route path="/authentication/wizard" element={WizardLayout} /> */}
        {/* <Route path="errors" element={<ErrorLayout />} /> */}
        <Route path="authentication/" element={<AuthBasicLayout />}>
          <Route path={`login`} element={<Login />} />
          <Route path={`logout`} element={<Logout />} />
          <Route path={`forbidden`} element={<Forbidden />} />
          {/* <Route path={`register`} element={<Registration />} /> */}
          <Route path={`forget-password`} element={<ForgetPassword />} />
          <Route path={`confirm-mail`} element={<ConfirmMail />} />
          <Route path={`password-reset`} element={<PasswordReset />} />
          {/* <Route path={`lock-screen`} element={<LockScreen />} /> */}
        </Route>
      </Routes>
    </div>
  );
};

export default Layout;
